var React = require('react');

function MimeArchive (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 0a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h4v2h2V0h4zM8 14.5c1.16 0 1.75-.314 1.75-1.833 0-.651-.268-1.398-.75-2.223V9H7v1.444c-.482.825-.75 1.572-.75 2.223 0 1.519.59 1.833 1.75 1.833zm0-2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zM7 8h2V6H7v2zm0-3h2V3H7v2z"}));
}

MimeArchive.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = MimeArchive;

MimeArchive.default = MimeArchive;
